import { render } from "./UserAccoutingItem.vue?vue&type=template&id=770eb32e&scoped=true"
import script from "./UserAccoutingItem.vue?vue&type=script&lang=js"
export * from "./UserAccoutingItem.vue?vue&type=script&lang=js"

import "./UserAccoutingItem.vue?vue&type=style&index=0&id=770eb32e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770eb32e"]])

export default __exports__